import axios from "axios";
import router from "../router";

const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api/' : process.env.VUE_APP_API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

const fixImageUrls = (data) => {
    if (typeof data === 'string' && data.startsWith('http://nginx/')) {
        return data.replace('http://nginx', '');
    }
    if (typeof data === 'object' && data !== null) {
        if (Array.isArray(data)) {
            return data.map(fixImageUrls);
        }
        const fixed = {};
        for (const key in data) {
            fixed[key] = fixImageUrls(data[key]);
        }
        return fixed;
    }
    return data;
};

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
    (response) => {
        if (process.env.NODE_ENV === 'development') {
            response.data = fixImageUrls(response.data);
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            router.push({ name: 'auth/login' });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
